import { postRequest } from "../../app/axiosClient";
import OpenNotificationWithIcon from "../../components/VibrantSolComponents/Notification";
import {
  showLoader,
  hideLoader,
} from "../../components/VibrantSolComponents/GlobalSpinnerSlice";
import { message } from "antd";
import {
  forgotPasswordFailure,
  forgotPasswordSuccess,
  loginSuccess,
  setPasswordSuccess,
  validateTokenResponse,
} from "./LoginSlice";

export const loginAPI = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Login`, values)
      .then((res) => {
        if (res?.data?.errorResponse) {
          OpenNotificationWithIcon(
            "error",
            res?.data?.errorResponse?.errorMessage
          );
          dispatch(hideLoader());
          return false;
        } else {
          dispatch(loginSuccess(res?.data));
          message.success("Login successful");
          dispatch(hideLoader());
          return true;
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        if (error?.response?.status === 400) {
          message.error("Please enter a valid username or password");
        } else {
          message.error("Please enter a valid username or password");
        }
        return false;
      });
  } catch (e) {
    message.error("Connection failed");
    dispatch(hideLoader());
    return false;
  }
};

export const googleLoginAPI = (creds) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Login/Google`, creds)
      .then((res) => {
        if (res?.data?.errorResponse) {
          OpenNotificationWithIcon(
            "error",
            res?.data?.errorResponse?.errorMessage
          );
          dispatch(hideLoader());
          return false;
        } else {
          dispatch(loginSuccess(res?.data?.user));
          message.success("Login successful");
          dispatch(hideLoader());
          return true;
        }
      })
      .catch((error) => {
        dispatch(hideLoader());
        if (error?.response?.status === 400) {
          message.error("Google login failed");
        } else {
          message.error("Google login failed");
        }
        return false;
      });
  } catch (e) {
    message.error("Connection failed");
    dispatch(hideLoader());
    return false;
  }
};

export const forgotPasswordAPI = (email) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/User/SendResetPasswordLink`, email)
      .then((res) => {
        dispatch(forgotPasswordSuccess(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        dispatch(
          forgotPasswordFailure(
            "The email address you entered is not associated with any registered users. Please check it and try again. If the problem persists, please contact support."
          )
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    dispatch(
      message.error(
        "error",
        "Error",
        "Oops! Something went wrong and we couldn't send the password reset link. Please try again or contact support if the problem persists."
      )
    );
  }
};

export const validatePasswordAPI = (token) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/User/ValidatePasswordResetRequest?token=${token}`)
      .then((res) => {
        dispatch(validateTokenResponse(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        message.error(
          "error",
          "Error",
          "Unable to validate password request. Please try again."
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    message.error(
      "error",
      "Error",
      "Unable to validate password request. Please try again."
    );
  }
};

export const setPasswordAPI = (object) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/User/SetPassword`, object)
      .then((res) => {
        dispatch(setPasswordSuccess(res?.data));
        dispatch(hideLoader());
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        message.error(
          "Oops! An error occurred while setting the new password. Please try again or contact support if the problem persists."
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    message.error(
      "Oops! An error occurred while setting the new password. Please try again or contact support if the problem persists."
    );
    return false;
  }
};
